import React, { Component, useEffect, useState } from 'react';
import crmServices from '../../wsclient/'
import { withStyles } from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next'
import FilterView from '../offers/FilterView'
import {domainName, portal_config} from '../../../portal.config'
import t from '../../utils/translateUtil';
import ModalAlert from '../../components/ModalAlert';
import LocationsView from './LocationsView';
import { eventTypeSimple, googleAnalytics } from '../../intergrations/google.analytics';
import LocationOffersView from './LocationOffersView';
import OfferDetail from '../offers/OfferDetail';
import { useHistory } from 'react-router-dom';
import { paths } from '../../../portal.router.config';
import LocationMerchantsView from './LocationMerchantsView';

const LATITUDE_DELTA = 0.06576;
const LONGITUDE_DELTA = 0.04142;
const DISTANCE = 1000000;

const styles = theme => ({

});
function LocationsController(props){
    const history = useHistory();
    const [showLoading, onShowLoading] = useState(false);
    const [offers, setOffers] = useState(null);
    const [merchants, setMerchants] = useState(null);
    const [currentLocation, setCurrentLocation] = useState(null);
    const [centerRegion, setCenterRegion] = useState(null);
    const [isRunning, setGetLocationStatus] = useState('start');
    const [isSelectedFilter, setIsSelectedFilter] = useState(false);
    const [filter_options, setFilterOptions] = useState(null);
    const [filter_options_org, setFilterOptionsOrg] = useState(null);
    const [zoomMap, setZoomMap] = useState(10);
    const [filterSelected, setFilterSelected] = useState({
        industry: [{ id: "All", name: "All" }],
        industry_sector: [{ id: "All", name: "All" }],
        tag: [{ id: "All", name: "All" }],
        // town_city: [{ id: "All", name: "All" }],
    });
    const [openFilter, setOpenFilter] = useState(false);
    const [message, setMessage] = useState({});
    const [params, setParams] = useState(null);
    const [locationCheckTimer, setLocationCheckTimer] = useState(null);
    const [lastRegion, setLastRegion] = useState(null);
    const [searchValue, setSearchValue] = useState(null);
    const [searchValueMerchant, setSearchValueMerchant] = useState(null);
    const [timerToChange, setTimerToChange] = useState(null);
    const [merchantsByName, setMerchantsByName] = useState([]);
    const [showSuggestBox, setShowSuggestBox] = useState(false);
    const [searchOrgName, setSearchOrgName] = useState(null)
    const [showDrawers, setShowDrawers] = useState({});

    useEffect(()=>{
        if(portal_config[domainName].isOfferFilter){
            getIndustriesAndIndustrySectors();
           // getIndustrySectors();
        }  
    },[]);

    useEffect(() => {
        if (isRunning == 'start') {
            let locationCheckTimer = setInterval(() => { getLocation(); }, 500);
            console.log(' locationCheckTimer===', locationCheckTimer)
            setLocationCheckTimer(locationCheckTimer)
        } else {
            stopCheckingLocation();
        }
        return () => clearInterval(locationCheckTimer);
    }, [isRunning]);

    useEffect(()=>{
        if(currentLocation){
            //getStores({ ...currentLocation });
            getRegion(currentLocation);
        }

    },[currentLocation])

    const stopCheckingLocation = () =>{
        setGetLocationStatus('stop');
        if (locationCheckTimer) {
            clearInterval(locationCheckTimer);
        }
    }

    const getLocation = async () => {
        console.log('currentLocation=======',currentLocation)

        // if (currentLocation) {
        //     console.log('LOCATION now is ', currentLocation)
        //     stopCheckingLocation();
        //     getStores({ ...currentLocation });
        //     getRegion(currentLocation);
        //     return;
        // }

        await navigator.geolocation.getCurrentPosition((location) => {
            let currentLocation = {
                lat: location.coords.latitude,
                lon: location.coords.longitude,
                // lat: 35.1868,
                // lon: 33.3754,
                // lat: 38.00934, 
                // lng: 22.459946,
                latitudeDelta: LATITUDE_DELTA,
                longitudeDelta: LONGITUDE_DELTA
            }
            // let currentLocation = {
            //     lat: 35.1868,
            //     lon: 33.3754
            // }
            setCurrentLocation(currentLocation);
            stopCheckingLocation();
            setParams(currentLocation);
        }, (err) => {
            console.log(' Offers getLocation err', err)
            onShowLoading(false);
            stopCheckingLocation();
            showMessage(true, t('enable_location_permissions'));
        }, {
            timeout: 5000,
            enableHighAccuracy: false
        });
        // console.log("AAAAAAAAAAAA getCurrentPosition currentLocation:", currentLocation);


    }
    const getRegion = (currentLocation) =>{
        if (currentLocation) {
            let region = {
                lat: currentLocation.lat,
                lon: currentLocation.lon,
                // latitudeDelta: 0.0922,
                // longitudeDelta: 0.0421,
            }
            setCenterRegion(region);
        }
    }

    const onRegionChangeComplete = (event)=>{
        console.log('onRegionChangeComplete=', event)
        let region = {
            lat: event.center.lat,
            lng: event.center.lng,
            // latitudeDelta: 0.0922,
            // longitudeDelta: 0.0421,
        }
        //setCenterRegion(region);
        onLoadStores(event);
    }
    const onLoadStores = async (region) =>{
        
       
        const extra = 2;
        //const distance = delta * 69 * extra/2;
        const distance = getDistanceFromLatLonInKm(region.center.lat, region.center.lng, region.bounds.ne.lat, region.bounds.ne.lng) * extra;

        let _params = {
            ...params,
            lat: region.center.lat,
            lon: region.center.lng,
            within: distance,
            sort: 'DISTANCE',
        }
        setParams(_params);

       // console.log('lastRegion==', lastRegion)
        if (lastRegion != null) {
            const lastLatDelta = lastRegion.bounds.ne.lat - lastRegion.center.lat
            const lastlonDelta = lastRegion.bounds.ne.lng - lastRegion.center.lng
            const lastDelta = lastLatDelta > lastlonDelta ? lastLatDelta : lastlonDelta;

            const lastTopRight = {
                lon: lastRegion.center.lng + lastDelta * extra, lat: lastRegion.center.lat + lastDelta * extra
            };

            const lastTopLeft = {
                lon: lastRegion.center.lng - lastDelta * extra, lat: lastRegion.center.lat + lastDelta * extra
            };

            const lastBottomRight = {
                lon: lastRegion.center.lng + lastDelta * extra, lat: lastRegion.center.lat - lastDelta * extra
            };

            const lastBottomLeft = {
                lon: lastRegion.center.lng - lastDelta * extra, lat: lastRegion.center.lat - lastDelta * extra
            };


            const nowTopRight = {
                lon: region.bounds.ne.lng, lat: region.bounds.ne.lat
            };

            const nowTopLeft = {
                lon: region.bounds.nw.lng, lat: region.bounds.nw.lat
            };

            const nowBottomRight = {
                lon: region.bounds.se.lng, lat: region.bounds.se.lat
            };

            const nowBottomLeft = {
                lon: region.bounds.sw.lng, lat: region.bounds.sw.lat
            };

            // console.log('lastTopRight=', lastTopRight)
            // console.log('lastTopLeft=', lastTopLeft)
            // console.log('lastBottomRight=', lastBottomRight)
            // console.log('lastBottomLeft=', lastBottomLeft)

            // console.log('nowTopRight=', nowTopRight)
            // console.log('nowTopLeft=', nowTopLeft)
            // console.log('nowBottomRight=', nowBottomRight)
            // console.log('nowBottomLeft=', nowBottomLeft)
            if (nowTopRight.lon > lastTopRight.lon || nowTopRight.lat > lastTopRight.lat ||
                nowTopLeft.lon < lastTopLeft.lon || nowTopLeft.lat > lastTopLeft.lat ||
                nowBottomRight.lon > lastBottomRight.lon || nowBottomRight.lat < lastBottomRight.lat ||
                nowBottomLeft.lon < lastBottomLeft.lon || nowBottomLeft.lat < lastBottomLeft.lat) {
                await getStores(_params, region);
            }
        }
        else {
            await getStores(_params, region);
        }
    }

    const getDistanceFromLatLonInKm = (lat1, lon1, lat2, lon2)=>{
        var R = 6371; // Radius of the earth in km
        var dLat = deg2rad(lat2 - lat1);  // deg2rad below
        var dLon = deg2rad(lon2 - lon1);
        var a =
            Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) *
            Math.sin(dLon / 2) * Math.sin(dLon / 2)
            ;
        var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        var d = R * c; // Distance in km
        return d;
    }

    const deg2rad = (deg)=>{
        return deg * (Math.PI / 180)
    }

    const getStores = async(params, region) =>{
        onShowLoading(true);
        let merchants = []
        try {
            //params.within = 1000;
            console.log("getStores params===", params)
            let result = await crmServices.rewards.getLocations({ ...params });
            console.log("OfferMap AAAAAA result getStores:", result)
            //this.setState({ showLoading: false });
            if (result.code == 'OK') {
                merchants = result.data && result.data.content ? result.data.content : [];
                if (region){
                    setLastRegion(region);
                }

                setMerchants(merchants);
            }
        } catch (error) {
            console.log("load merchants exception:", error);
        }
        onShowLoading(false);
        return merchants;
    }
    const addedImage = async(merchants) =>{
        let newMerchants = [];
        if (merchants.length > 0) {
            for (let i = 0; i < merchants.length; i++) {
                let merchant = merchants[i];
                let detailResult = await crmServices.rewards.getOrganisationDetail(merchant.id);
                //console.log("OfferMap AAAAAA result getOrganisationDetail:", detailResult)
                if (detailResult.code === 'OK') {
                    merchant.creatives = detailResult.data.creatives;
                    merchant.phone_number = getContactPhone(detailResult.data.contact_info);
                }
                newMerchants.push(merchant);
            }
        }
        return newMerchants;
    }
    const getContactPhone = (contact_info) =>{
        let phone_number = "";
        if (contact_info && contact_info.length > 0) {
            let phones = contact_info.filter(contact => {
                return contact.type === 'PHONE';
            })
            if (phones && phones.length > 0) {
                phone_number = phones[0].value;
            }
        }
        return phone_number;
    }
    const onLoadOffers = async(params) =>{
        try {
            let result = await crmServices.rewards.getOffers(params);
            //console.log('onLoadOffers=== ', result)
            if (result.code === 'OK') {
                let offers = result.data && result.data.content ? result.data.content : [];
                let newOffers = [];
                if (offers.length > 0) {
                    for (let i = 0; i < offers.length; i++) {
                        let offer_data = offers[i];
                        if(offer_data.performance_enabled){ 
                            let performanceData = await loadPerformance(offer_data.id);
                            offer_data.performance_data = performanceData;
                        }
                        newOffers.push(offer_data);
                    }
                }
                setOffers(newOffers);
            } else {

            }
        } catch (error) {
            console.log("on select merchant error:", error);
        }
    }
    const loadPerformance = async(offerId) => {
        let performance_data = null;
        try {
            let result = await crmServices.rewards.getPerformanceOffer(offerId);
            if (result.code === 'OK') {
                performance_data = result.data;
            }
        } catch (error) {
            console.log("load offer exception:", error);
        }
        return performance_data;
    }
    const onSelectMerchant = async (merchant) =>{
        googleAnalytics.sendLogEvents(eventTypeSimple.find_location);

        // setSearchValue(merchant.name);
        setSearchValueMerchant('');
        setSearchValue('');
        setShowSuggestBox(false)
        setMerchantsByName([]);

        if (merchant.location && merchant.location.lat && merchant.location.lon) {
            setCenterRegion(merchant.location);
            setZoomMap(12);
        }
        onShowLoading(true);
        await onLoadOffers({ organisations: merchant.id });
        setShowDrawers(prevState => ({
            ...prevState,
            merchant: {
                show: true,
                item: merchant,
            },
        }));
        onShowLoading(false);
    }

   
    const getIndustriesAndIndustrySectors = async() =>{
        let filter_options = {...filter_options_org}
        let content = [];
        try {
            let result = await crmServices.config.getIndustries();
            console.log('getIndustries result=', result)
            if (result.code == 'OK') {
                content = result.data && result.data.content ? result.data.content : [];
                filter_options.industries = content;
            }
        } catch (error) {
            console.log("get industries error:", error);
        }

        try {
            let result = await crmServices.config.getIndustrySectors();
            if (result.code == 'OK') {
                content = result.data && result.data.content ? result.data.content:[];
                filter_options.industry_sectors = content
            }
        } catch (error) {
            console.log("get industries error:", error);
        }
        setFilterOptionsOrg(filter_options);
    }
    
    const getTags = async(new_filter_options, _filterSelected) =>{
        let content = [];
        try {
            let params = {};
            params = getFilterParamByType("industry", "industry", params, _filterSelected);
            params = getFilterParamByType("industry_sector", "industry_sector", params, _filterSelected);
            if (params.industry || params.industry_sector) {
                let result = await crmServices.config.getOrganisationTags(params);
                if (result.code == 'OK') {
                    content = result.data && result.data.content ? result.data.content : [];
                }
            }
        } catch (error) {
            console.log("get industries error:", error);
        }
        let temp_filter_options = new_filter_options;
        console.log("AA filter_options:",temp_filter_options);
        if(content.length > 0){ 
            temp_filter_options.tags = [{ id: "All", name: "All" },...content];
        }else{
            temp_filter_options.tags = [{ id: "All", name: "All" }];
        }
        setFilterOptions(temp_filter_options)
        return temp_filter_options;
    }

    const onSelectFilter = async(type, value) =>{
        let new_filter_options = {...filter_options};
        let newFilterSelected = {...filterSelected};
        let industry_sectors = filter_options_org.industry_sectors;
        if (value.id === 'All') {
            newFilterSelected[type] = [{ id: "All", name: "All" }];
            if (type === 'industry') {
                var filterSector = [];
                //if (industry_sectors && industry_sectors[0] && industry_sectors[0].id != 'All') {
                    industry_sectors = [{ id: "All", name: "All" }, ...industry_sectors];
                //}
                filterSector = industry_sectors
                newFilterSelected.industry_sector = [{ id: "All", name: "All" }];
                newFilterSelected.tag = [{ id: "All", name: "All" }];

                new_filter_options.industry_sectors = filterSector;
            }
        }
        else {
            if (newFilterSelected[type].length == 1 && newFilterSelected[type][0].id == 'All') {
                newFilterSelected[type].splice(0, 1);
            }
            let index = -1;
            for (let i = 0; i < newFilterSelected[type].length; i++) {
                if (newFilterSelected[type][i].id === value.id) {
                    index = i;
                    break;
                }
            }
            if (index >= 0) {
                // newFilterSelected[type].splice(index, 1);
                let industrySelectedIndex = newFilterSelected[type][index];
                newFilterSelected[type].splice(index, 1);
                if(type=='industry'){
                    var industrySectorsSelected = newFilterSelected.industry_sector;
                    industrySectorsSelected.forEach(element => {
                        let related_industries = element.related_industries;
                        let exist = related_industries && related_industries.filter(e => {
                            return e.id == industrySelectedIndex.id;
                        })
                        if(exist && exist.length > 0){
                            industrySectorsSelected = industrySectorsSelected.filter(sector => {
                                return sector.id != element.id
                            })
                        }
                    });
                    newFilterSelected.industry_sector = industrySectorsSelected;
                }
            }
            else {
                newFilterSelected[type].push(value);
            }
            if (type == 'industry') {
                var filterSector = [];
                var industrySelected = newFilterSelected.industry;
                industrySelected.forEach(industry => {
                    industry_sectors.forEach(sector => {
                        let related_industries = sector.related_industries;
                        let itemExist = related_industries && related_industries.filter(i => {
                            return i.id == industry.id
                        })
                        if (itemExist && itemExist.length > 0) {
                            filterSector.push(sector);
                        }
                    })
                })
                new_filter_options.industry_sectors = [{ id: "All", name: "All" }, ...filterSector];
            }
            if (newFilterSelected[type].length == 0) {
                newFilterSelected[type] = [{ id: "All", name: "All" }]
                filterSector = [{ id: "All", name: "All" }, ...industry_sectors];

                new_filter_options.industry_sectors = filterSector;
                if (type == 'industry_sector') {
                    var filterSector = [];
                    var industrySelected = newFilterSelected.industry;
                    industrySelected.forEach(industry => {
                        industry_sectors.forEach(sector => {
                            var related_industries = sector.related_industries;
                            var itemExist = related_industries && related_industries.filter(i => {
                                return i.id == industry.id
                            })
                            if (itemExist && itemExist.length > 0) {
                                filterSector.push(sector);
                            }
                        })
                    })
                    new_filter_options.industry_sectors = [{ id: "All", name: "All" }, ...filterSector];
                }
            }
        }

        if (type == 'industry_sector') {
            newFilterSelected.tag = [{ id: "All", name: "All" }];
        }
        new_filter_options = await getTags(new_filter_options, newFilterSelected);
        setFilterOptions(new_filter_options);
        setFilterSelected(newFilterSelected);
        setIsSelectedFilter(true);
    }
    
    const onFilter = async() =>{
        onShowLoading(true);
        let new_params = { ...params }
        new_params = getFilterParamByType("industry", "industries", new_params);
        new_params = getFilterParamByType("industry_sector", "industry_sectors", new_params);
        new_params = getFilterParamByType("tag", "organisation_tags", new_params);
        // new_params = getFilterParamByType("town_city", "town_cities", new_params);
        await getStores(new_params);

        setOffers([]);
        onShowLoading(false);
    }

    const getFilterParamByType = (selectedType, paramType, params, _filterSelectedList) =>{
        if(!_filterSelectedList){
            _filterSelectedList = filterSelected;
        }
        let newFilterSelected = _filterSelectedList[selectedType];
        if (newFilterSelected.length > 0 && newFilterSelected[0].id != 'All') {
            params[paramType] = "";
            for (let i = 0; i < newFilterSelected.length; i++) {
                if (i == newFilterSelected.length - 1) {
                    params[paramType] = params[paramType] + newFilterSelected[i].id;
                } else {
                    params[paramType] = params[paramType] + newFilterSelected[i].id + ",";
                }
            }
        }
        else {
            delete params[paramType]
        }
        return params;
    }
    const onOpenFilter = async() =>{
        let filter_options = { ...filter_options_org };
        console.log('onOpenFilter filter_options==', filter_options)
        filter_options.industries = [{ id: "All", name: "All" }, ...filter_options.industries];
        filter_options.industry_sectors = [{ id: "All", name: "All" }, ...filter_options.industry_sectors];
        filter_options.tags=[{id: "All", name: "All"}]
        // filter_options.town_city = [{id: "All", name: "All"}];
        let industrySelected = filterSelected.industry;
        if (industrySelected.length > 0 && industrySelected[0].id != 'All') {
            let industry_sectors = filter_options.industry_sectors;
            let filterSector = [];
            industrySelected.forEach(industry => {
                industry_sectors.forEach(sector => {
                    let related_industries = sector.related_industries;
                    if (related_industries) {
                        let itemExist = related_industries && related_industries.filter(i => {
                            return i.id == industry.id
                        })
                        if (itemExist && itemExist.length > 0) {
                            filterSector.push(sector);
                        }
                    }
                })
            })
            filter_options.industry_sectors = [{ id: "All", name: "All" }, ...filterSector];
        }
        setOpenFilter(true);
        setFilterOptions(filter_options);
        setIsSelectedFilter(false);
        await getTags(filter_options);
    }
    const onCloseFilter = () =>{
        if(isSelectedFilter){
            onFilter();
        }
        setOpenFilter(false);
    }
    const onDirection = (direction) =>{
        //console.log('direction:', direction);
        if (direction) {
            let url = 'https://www.google.com/maps/search/?api=1';
            if (direction.lat && direction.lon) {
                url = url + '&query=' + direction.lat + "," + direction.lon;
            }
            if (direction.googleplaceid) {
                url = url + '&query_place_id=' + direction.googleplaceid;
            }
            //console.log("url:", url);
            window.open(url)
            //Linking.openURL(url);
            // openMap({ end: direction.lat + "," + direction.lon, provider: provider });
        }
    }
    const onSearchPlace = (detail) =>{
        //console.log("onSearchPlace detail:",detail);
        //let geometry = detail.geometry.location;
        console.log('onSearchPlace===========', detail)
        let location = {
            lat: detail.lat,
            lon: detail.lon,
        }
        setCenterRegion(location);
        setZoomMap(12);
    }
    const showMessage = (status, message) =>{
        onShowLoading(false);
        setMessage({
            show: status,
            content: message ? message : null
        })
    }
    const onHandleChange = async (value, target) => {
        console.log("targer AAA:", target);
        console.log("value AAA:", value);
        if(target === 'merchantpage') setSearchValueMerchant(value);
        else setSearchValue(value);
        // if(searchType=='google'){
        if (value) {
            clearTimeout(timerToChange);
            let timer = setTimeout(async () => {
                await triggerChange(target, value)
            }, 2000);
            setTimerToChange(timer);
        } else {
            var _params = { ...params }
            setMerchantsByName([]);
            setSearchValue(undefined)
            await getStores(_params, null)
            setSearchOrgName(undefined)
            clearTimeout(timerToChange)
            setShowSuggestBox(false);
        }
        //}else{ 
        //    filterMerchant(value);
        //}
    }

    const triggerChange = async (target, value) => {
        var _params = { ...params }
        _params.organisation_name = value;
        _params.within = DISTANCE;
        let merchants = await getStoresByName(_params);
        //console.log('merchants=========', merchants)
        setMerchantsByName(merchants);
        if (merchants.length > 0) {
            setShowSuggestBox(true);
        }
    }
    const getStoresByName = async (params) => {
        onShowLoading(true)
        var _merchants = []
        try {
            console.log("AAAAAAAAAAAAA getStoresByName: ", params);
            var result = await crmServices.rewards.getLocations(params);
            console.log('getStoresByName getStores: ', result )
            if (result.code == 'OK') {
                _merchants = result.data && result.data.content ? result.data.content : [];
                onShowLoading(false);
            } else {
                onShowLoading(false);
            }

        } catch (error) {
            console.log("load merchants exception:", error);
            onShowLoading(false);
        }
        return _merchants;
    }
    const onSelectAddress = (add) =>{
        if (searchOrgName) {
            setLastRegion(null);
            setSearchOrgName(null);
        }
        setSearchValue(add.address);
        setOffers([]);
        onSearchPlace(add)
    }

    const onSelectOffer = (offer) => {
        setShowDrawers(prevState => ({
            ...prevState,
            offer: {
                show: true,
                item: offer,
            },
        }));
    }

    const onCloseDrawer = (target) => {
        setShowDrawers(prevState => ({
            ...prevState,
            [target]: {},
        }))
    }

    const onOpenDrawers = (target, data) => {
        setShowDrawers(prevState => ({
            ...prevState,
            [target]: data,
        }))
    }

    const onCloseMap = () =>{
        history.push(paths.home);
    }
    console.log('current location=====', currentLocation)
    return (
        <div>
            {/* <Loading showLoading={showLoading} /> */}
            <LocationsView
                showLoading={showLoading}
                open={props.open}
                offers={offers}
                centerRegion={centerRegion}
                zoomMap = {zoomMap}
                merchantsByName={merchantsByName}
                showSuggestBox={showSuggestBox}
                searchValue={searchValue}
                searchValueMerchant={searchValueMerchant}
                showDrawers={showDrawers}
                onCloseMap={onCloseMap}
                onSelectFilter={onSelectFilter}
                merchants={merchants}
                onSelectMerchant={onSelectMerchant}
                onOpenFilter={onOpenFilter}
                onDirection={onDirection}
                onShowOfferDetail = {props.onShowOfferDetail} 
                onRegionChangeComplete={onRegionChangeComplete}
                onHandleChange={onHandleChange}
                setShowSuggestBox={setShowSuggestBox}
                onSelectAddress={onSelectAddress}
                onOpenDrawers={onOpenDrawers}
                setSearchValue={setSearchValue}
                />
            {openFilter&&<FilterView open={openFilter}
                onClose={onCloseFilter}
                filter_options={filter_options}
                filterSelected={filterSelected}
                from="locations"
                onSelectFilter={onSelectFilter}
                onApplyFilter = {onCloseFilter}/>}  
            {message && <ModalAlert
                open={message.show}
                onClose={showMessage}
                message={message.content}
            />}  
            {showDrawers && showDrawers.merchant && showDrawers.merchant.show && <LocationOffersView 
                open={showDrawers.merchant.show}
                merchant={showDrawers.merchant.item}
                offers={offers}
                onClose={() => onCloseDrawer('merchant')}
                onSelectOffer={onSelectOffer}
                onDirection={onDirection}
            />}
            {showDrawers && showDrawers.offer && showDrawers.offer.show && <OfferDetail 
                open={showDrawers.offer.show}
                offer={showDrawers.offer.item}
                handleDrawerToggle={() => onCloseDrawer('offer')}
            /> }
            {showDrawers && showDrawers.merchants && showDrawers.merchants.show && <LocationMerchantsView 
                open={showDrawers.merchants.show}
                currentLocation={currentLocation}
                within={params && params.within ? params.within : null}
                onClose={() => onCloseDrawer('merchants')}
                showLoading={showLoading}
                offers={offers}
                centerRegion={centerRegion}
                zoomMap={zoomMap}
                merchantsByName={merchantsByName}
                showSuggestBox={showSuggestBox}
                searchValueMerchant={searchValueMerchant}
                onCloseMap={props.onCloseMap}
                onSelectFilter={onSelectFilter}
                merchants={merchants}
                onSelectMerchant={onSelectMerchant}
                onOpenFilter={onOpenFilter}
                onDirection={onDirection}
                onShowOfferDetail={props.onShowOfferDetail}
                onHandleChange={onHandleChange}
                setShowSuggestBox={setShowSuggestBox}
                onSelectAddress={onSelectAddress}
            /> }
        </div>
    );
}

export default withStyles(styles)(withTranslation()(LocationsController));